
const challenge = (Math.random() + 1)
  .toString(36)
  .split('.')
  .pop() || ''
  .substring(36)

export const creationOptions = {
  challenge,
  rp: {
    name: '',
    id: window.location.hostname
  },
  user: {
    id: '',
    name: '',
    displayName: ''
  },
  pubKeyCredParams: [{
    alg: -7,
    type: 'public-key'
  },
  {
    type: 'public-key',
    alg: -257
  }
  ],
  authenticatorSelection: {
    authenticatorAttachment: 'platform'
  },
  timeout: 60000,
  attestation: 'direct'
}

export const requestOptions = {
  challenge,
  rpId: window.location.hostname,
  allowCredentials: [{
    id: '',
    type: 'public-key',
    transports: ['internal']
  }],
  userVerification: 'required',
  timeout: 60000
}
